import { ErrorsService } from "src/app/services/common/errors.service";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder } from "@angular/forms";
import * as moment from "jalali-moment";


import { IBranch } from "src/app/interfaces/branch";
import { IPlacementType } from "src/app/interfaces/placementType";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IPlacementReservationTime } from "src/app/interfaces/placementReservationTime";
import { IPlacementTimeSheetGetDateList } from "src/app/interfaces/placement-timeSheet-GetDateList";
import { PlacementTiemSheetService } from "src/app/services/http/business/placement/placement-tiem-sheet.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BIDService } from "src/app/services/common/bid.service";
import { MatSelect, MatCalendarCellCssClasses } from "@angular/material";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { PlacementPaymentComponent } from "../placement-payment/placement-payment.component";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { IPlacementReservationAdd } from "src/app/interfaces/placementReservationAdd";
import { HidService } from "src/app/services/common/hid.service";
import * as momentJalali from "jalali-moment";
import { environment } from "src/environments/environment";
import { IProvince } from "src/app/interfaces/province";
import { ProvinceService } from "src/app/services/http/business/province/provinces.service";
import { IError } from "src/app/interfaces/error.interface";


@Component({
  selector: "app-placement-reservation-entry",
  templateUrl: "./placement-reservation-entry.component.html",
  styleUrls: ["./placement-reservation-entry.component.css"],
  providers: [ErrorsService]
})
export class PlacementReservationEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  personInfo: any;
  holdings: any;
  HoldingEncryptId: string;
  errors = new Array();
  nationalCode: string;
  reserveTimeList: any;
  notExistTime = false;
  branchesList: IBranch[];
  form: FormGroup;
  hideHolding: boolean = true;
  hideBranche: boolean = true;
  hideTimeReserved: boolean = true;
  hidePlacementDate: boolean = true;
  hidePlacementType: boolean = true;
  placementTypeList: IPlacementType[];
  provinceList: IProvince;
  reservationDateList: IPlacementTimeSheetGetDateList[];
  queryParams: any;
  dateFilter: () => any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private bidService: BIDService,
    private hidService: HidService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchSewrvice: BranchService,
    private holdingService: HoldingService,
    private provinceService: ProvinceService,
    private studentService: StudentService,
    private placementTimeSheetServie: PlacementTiemSheetService,
    private dialogRef: MatDialogRef<PlacementReservationEntryComponent>
  ) { }

  ngOnInit() {
    this.queryParams = {
      holdingEncryptId: this.hidService.getHID()
    };
    this.createReservationAddForm();
    this.holdingService.allList().subscribe(res => {
      this.hidService.setHID(res.DataList[0].HoldingEncryptCode);
      //this.getAllHolding();
    });
    this.loadProvience();
  }

  onSelectDate(event) {

    let date = moment
      .from(event, "en")
      .utc(true)
      .format(environment.dateFormat);
    console.log(this.form.value);


    this.form.controls['Date'].setValue(date);

    this.loadPlacementReservationTime(this.form.value)
  }

  //لیست تمام هولدینگ ها برای دانشجویان
  getAllHolding() {
    // this.holdingService.checkOwnerHolding().subscribe(res => {
    //   // if (res.IsOwner) {
    //   //   this.holdingService.list().subscribe(res => {
    //   //     this.holdings = res.DataList;
    //   //     if (res.Total > 1) {
    //   //       this.hideHolding = false;
    //   //     } else {
    //   //       this.form.controls['HoldingEncryptId'].setValue(this.holdings[0].HoldingEncryptCode);
    //   //       this.loadBranches(this.form.value);
    //   //       this.hideBranche = false;
    //   //     }
    //   //   });
    //   // }
    //   // else {

    //     // this.loadBranches(this.form.value);
    //     //}
    //   })
    this.hideHolding = true;
    this.hideBranche = false;

  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }

  loadBranches(form: any) {

    this.branchesList = [];
    this.placementTypeList = [];
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.form.controls['BranchEncryptId'].setValue(null);
    this.form.controls['PlacementTypeId'].setValue(null);
    this.form.controls['Date'].setValue(null);
    this.form.controls['TimeReserved'].setValue(null);
    //this.form.controls['HoldingEncryptId'].setValue(this.hidService.getHID());
    this.HoldingEncryptId = form.HoldingEncryptId;
    this.getBranches(form);
    this.hideBranche = false;
  }

  getRealTime(reserveTime) {
    var dateObj = new Date();
    var hours = dateObj.getHours();
    var minutes = dateObj.getMinutes();
    var seconds = dateObj.getSeconds();

    var timeString = hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + ':' +
      seconds.toString().padStart(2, '0');
    if (reserveTime >= timeString)
      return true;
    else
      return false;
  }

  createReservationAddForm() {
    this.form = this.fb.group({
      //NationalCode: [this.nationalCode],
      Date: [null, Validators.compose([Validators.required])],
      TimeReserved: [null, Validators.compose([Validators.required])],
      BranchEncryptId: [null, Validators.compose([Validators.required])],
      HoldingEncryptId: [this.hidService.getHID(), Validators.compose([Validators.required])],
      PlacementTypeId: [null, Validators.compose([Validators.required])],
      ProvinceId: [null, Validators.required]
    });
  }

  getBranches(queryParams: any) {
    this.branchSewrvice.listByHoldingIdAndCurrentSTU(queryParams).subscribe(
      res => {

        this.branchesList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementType(form: MatSelect) {

    this.placementTypeList = [];
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.form.controls['PlacementTypeId'].setValue(null);
    this.form.controls['Date'].setValue(null);
    this.form.controls['TimeReserved'].setValue(null);
    //this.queryParams.branchEncryptId = e.value;
    this.studentService.getPlacementTypeListSTU(form).subscribe(
      res => {

        this.placementTypeList = res.DataList;
        if (this.placementTypeList.length == 0)
          this.snackBar.OpenSnackBar(
            this.translate.get("error.placementTypeIsNotInBranch", {
              size: "100kb"
            }),
            "ok",
            3000,
            SoundEnum.beep
          );
        else {
          this.hidePlacementType = false;
          this.hidePlacementDate = true;
          this.hideTimeReserved = true;
        }

      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadReservationDate(form: any) {

    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.form.controls['Date'].setValue(null);
    this.form.controls['TimeReserved'].setValue(null);
    this.studentService.getDateList(form).subscribe(
      res => {

        this.reservationDateList = res;
        this.hidePlacementDate = false;
        this.hideTimeReserved = true;
        this.dateFilter = (): any => {
          return (dateParams): MatCalendarCellCssClasses => {
            let data = momentJalali.from(dateParams, "en").utc(true).format("YYYY-MM-DDTHH:mm:ss");
            let arry = [];
            arry = this.reservationDateList;
            let temp = arry.find(x => x.Date == data);
            return !temp ? 'disabled' : '';
          }
        };
      },
      () => {
        this.errorService.transactionError();
      });
  }
  test(form) {

    console.log(form);

  }
  loadReservationDateDirect(placementType) {
    this.reservationDateList = [];
    this.reserveTimeList = [];
    this.form.controls['Date'].setValue(null);
    this.form.controls['TimeReserved'].setValue(null);
    var data: IPlacementReservationTime = {
      BranchEncryptId: this.bidService.getBID(),
      PlacementTypeId: placementType
    };
    this.placementTimeSheetServie.GetDateList(data).subscribe(
      res => {
        this.reservationDateList = res;
        this.hidePlacementDate = false;
        this.hideTimeReserved = true;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementReservationTime(form: any) {

    this.reserveTimeList = [];
    this.form.controls['TimeReserved'].setValue(null);
    // this.queryParams.date = date;
    this.studentService.placementReservationTime(form).subscribe(
      res => {
        if (res.length <= 0)
          this.notExistTime = true;
        else
          this.notExistTime = false;
        this.reserveTimeList = res;
        this.hideTimeReserved = false;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  // create Reservation and send from payment
  createReservation(form: IPlacementReservationAdd) {

    this.errors = new Array();
    this.studentService.reservationAdd(form).subscribe(
      res => {

        this.dialog.open(PlacementPaymentComponent, {
          data: res.returnValue
        }).afterClosed().subscribe(() => {
          this.dialogRef.close();
        });
        this.dialogRef.close();
        // this.snackBar.OpenSnackBar(
        //   this.translate.get("success.registration"),
        //   "ok",
        //   5000,
        //   SoundEnum.beep
        // );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
